const generateSegmentData = props => {
  const isMobile = window && window.innerWidth < 768;
  return {
    ...props,
    platform: isMobile ? 'mobile' : 'web',
    product: 'your registry',
  };
};

export default generateSegmentData;
